<template>
  <div>
    <ValidationObserver v-slot="{ handleSubmit, reset }">
      <b-form ref="productForm" @submit.prevent="handleSubmit(save)" @reset.prevent="reset">
        <div class="d-flex flex-md-row flex-column mb-3">
          <div class="pe-lg-2">
            <image-uploader
              class="img-fluid"
              v-model="productImage"
              :isRequired="true"
              :imageSrc="productTemplateItem.productImageSrc"
            />
          </div>

          <div class="px-lg-2">
            <div class="card">
              <div class="card-body">
                <div>
                  <b-col sm="12" class="mb-1">
                      <label v-if="productId == undefined && !productSuggestionModule.access.create" class="form-label medium fw-bold text-danger mb-3">Note: Your access is limited. You cannot create a Product Suggestion.</label>
                      <label v-else-if="(productId > 0 || productId != undefined) && !productSuggestionModule.access.update" class="form-label medium fw-bold text-danger mb-3">Note: Your access is limited. You cannot update a Product Suggestion.</label>    
                  </b-col>
                  <b-row>
                    <b-col sm="12" class="mb-3">
                      <label class="form-label small fw-bold"
                        >Product Name*</label
                      >
                      <validation-provider
                        name="product name"
                        rules="required"
                        v-slot="validationContext"
                      >
                        <b-form-input
                          :state="getValidationState(validationContext)"
                          type="text"
                          class="form-control"
                          v-model="productTemplateItem.productName"
                          placeholder="Enter Product Name"
                        />
                        <b-form-invalid-feedback>
                          {{ validationContext.errors[0] }}
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </b-col>

                    <b-col sm="12" class="mb-3">
                      <label class="form-label small fw-bold"
                        >Product Brand*</label
                      >
                      <validation-provider
                        name="product brand"
                        rules="required"
                        v-slot="{ errors, ariaMsg }"
                      >
                        <multiselect
                          v-model="productBrand"
                          :options="productBrandOptions"
                          track-by="value"
                          label="text"
                          name="brandCategory"
                          select-label="Click to select"
                          deselect-label="Click to remove"
                          placeholder="Select Product Brand"
                          :allow-empty="true"
                          :preselect-first="false"
                          :class="{
                            invalid: errors[0],
                          }"
                        ></multiselect>
                        <b-form-invalid-feedback v-bind="ariaMsg">
                          {{ errors[0] }}
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col sm="12" class="mb-3">
                      <label class="form-label small fw-bold"
                        >Business Category*</label
                      >
                      <validation-provider
                        name="business category"
                        rules="required"
                        v-slot="{ errors, ariaMsg }"
                      >
                        <multiselect
                          :multiple="true"
                          v-model="productCategories"
                          :options="productCategoryOptions"
                          track-by="value"
                          label="text"
                          name="productCategory"
                          select-label="Click to select"
                          deselect-label="Click to remove"
                          placeholder="Select Business Categories"
                          :allow-empty="true"
                          :preselect-first="false"
                          :hide-selected="true"
                          :close-on-select="false"
                          :class="{
                            invalid: errors[0],
                          }"
                        ></multiselect>
                        <b-form-invalid-feedback v-bind="ariaMsg">
                          {{ errors[0] }}
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </b-col>
                    <b-col sm="12" class="mb-3">
                      <label class="form-label small fw-bold"
                        >Product Category*</label
                      >
                      <validation-provider
                        name="product group"
                        rules="required"
                        v-slot="{ errors, ariaMsg }"
                      >
                        <multiselect
                          v-model="productGroup"
                          :options="productGroupOptions"
                          track-by="value"
                          label="text"
                          name="brandCategory"
                          select-label="Click to select"
                          deselect-label="Click to remove"
                          placeholder="Select Product Category"
                          :allow-empty="true"
                          :preselect-first="false"
                          :class="{
                            invalid: errors[0],
                          }"
                        ></multiselect>
                        <b-form-invalid-feedback v-bind="ariaMsg">
                          {{ errors[0] }}
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </b-col>
                  </b-row>

                  <hr class="mb-4" />
                  <b-row>
                    <b-col sm="12" class="mb-3">
                      <b-btn class="pull-right btn-sm" type="button" variant="primary" @click="openCreateNewUom('bv-modal-uom')">Create New UOM</b-btn>
                      <label class="form-label small fw-bold mb-3"
                        >Unit of Measurement*</label
                      >
                      <validation-provider
                        name="product unit method"
                        rules="required"
                        v-slot="{ errors, ariaMsg }"
                      >
                        <multiselect
                          v-model="selectedUOM"
                          :options="unitOfMeasurementList"
                          track-by="unit"
                          label="name"
                          name="brandCategory"
                          :custom-label = "labelWithUnit"
                          select-label="Click to select"
                          deselect-label="Click to remove"
                          placeholder="Select Unit of Measurement"
                          :allow-empty="true"
                          :preselect-first="false"
                          :class="{
                            invalid: errors[0],
                          }"
                        ></multiselect>
                        <b-form-invalid-feedback v-bind="ariaMsg">
                          {{ errors[0] }}
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </b-col>
                  </b-row>


                  <b-row v-if="false">
                    <b-col sm="12" class="mb-3">
                      <label class="form-label small fw-bold"
                        >Unit of Measurement*</label
                      >
                      <validation-provider
                        name="product unit method"
                        rules="required"
                        v-slot="{ errors, ariaMsg }"
                      >
                        <multiselect
                          v-model="uomMethod"
                          :options="uomOptions"
                          track-by="value"
                          label="text"
                          name="brandCategory"
                          select-label="Click to select"
                          deselect-label="Click to remove"
                          placeholder="Select Unit Method"
                          :allow-empty="true"
                          :preselect-first="false"
                          :class="{
                            invalid: errors[0],
                          }"
                        ></multiselect>
                        <b-form-invalid-feedback v-bind="ariaMsg">
                          {{ errors[0] }}
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </b-col>
                  </b-row>

                  <b-row v-if="false">
                    <b-col sm="6" class="mb-3">
                      <label class="form-label small fw-bold">Unit Name*</label>
                      <validation-provider
                        name="product unit name"
                        rules="required"
                        v-slot="validationContext"
                      >
                        <b-form-input
                          :state="getValidationState(validationContext)"
                          type="text"
                          class="form-control"
                          v-model="productTemplateItem.uom.name"
                          placeholder="Enter Unit Name Name"
                        />
                        <b-form-invalid-feedback>
                          {{ validationContext.errors[0] }}
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </b-col>
                    <b-col sm="6" class="mb-3">
                      <label class="form-label small fw-bold">Unit Symbol*</label>
                      <validation-provider
                        name="product unit symbol"
                        rules="required"
                        v-slot="validationContext"
                      >
                        <b-form-input
                          :state="getValidationState(validationContext)"
                          type="text"
                          class="form-control"
                          v-model="productTemplateItem.uom.unit"
                          placeholder="Enter Unit Symbol"
                        />
                        <b-form-invalid-feedback>
                          {{ validationContext.errors[0] }}
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col sm="6" class="mb-3">
                      <label class="form-label small fw-bold">SRP Price*</label>
                      <validation-provider
                        name="product srp"
                        rules="required"
                        v-slot="validationContext"
                      >
                        <div class="input-group">
                          <span class="input-group-text">₱</span>
                          <b-form-input
                            @keypress="isNumber($event)"
                            :state="getValidationState(validationContext)"
                            type="number"
                            step="0.01"
                            class="form-control"
                            v-model="productTemplateItem.srp"
                            placeholder="Enter SRP Price"
                          />
                        </div>
                        <b-form-invalid-feedback>
                          {{ validationContext.errors[0] }}
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </b-col>

                    <b-col sm="6" class="mb-3">
                      <label class="form-label small fw-bold">Cost Price*</label>
                      <validation-provider
                        name="product cost"
                        rules="required"
                        v-slot="validationContext"
                      >
                        <div class="input-group">
                          <span class="input-group-text">₱</span>
                          <b-form-input
                            @keypress="isNumber($event)"
                            type="number"
                            step="0.01"
                            :state="getValidationState(validationContext)"
                            class="form-control"
                            v-model="productTemplateItem.cost"
                            placeholder="Enter Cost Price"
                          />
                        </div>
                        <b-form-invalid-feedback>
                          {{ validationContext.errors[0] }}
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col class="mb-4">
                      <label class="form-label small fw-bold">SKU*</label>
                      <validation-provider
                        name="product SKU"
                        rules="required"
                        v-slot="validationContext"
                      >
                        <div class="input-group">
                          <span class="input-group-text">
                            <i class="bx bx-barcode bx-sm"></i>
                          </span>
                          <b-form-input
                            :state="getValidationState(validationContext)"
                            type="text"
                            class="form-control"
                            v-model="productTemplateItem.productCode"
                            placeholder="Enter SKU"
                          />
                        </div>
                        <b-form-invalid-feedback>
                          {{ validationContext.errors[0] }}
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </b-col>
                  </b-row>

                  <b-row class="mb-3">
                    <b-col
                      ><b-btn :disabled="productId == undefined ? !productSuggestionModule.access.create : !productSuggestionModule.access.update" class="w-100" type="submit" variant="primary"
                        >Save</b-btn
                      ></b-col
                    >
                    <b-col v-show="false"
                      ><b-btn ref="formReset" class="w-100" type="reset" variant="primary"
                        >Reset</b-btn
                      ></b-col
                    >
                    <b-col
                      ><b-btn class="w-100 btn btn-light" @click="goBack"
                        >Cancel</b-btn
                      ></b-col
                    >
                  </b-row>
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-form>
    </ValidationObserver>
    <!-- add unit of measurements -->
    <b-modal id="bv-modal-uom" title="Unit of Measurement" size="md" hide-footer hide-header-close>
      <div class="mt-4">
        <ValidationObserver v-slot="{ handleSubmit, reset }">
          <b-form ref="productForm" @submit.prevent="handleSubmit(newUOM)" @reset.prevent="reset">
            <b-row>
              <b-col sm="6" class="mb-3">
                <label class="form-label small fw-bold">Unit Name*</label>
                <validation-provider
                  name="product unit name"
                  rules="required"
                  v-slot="validationContext"
                >
                  <b-form-input
                    :state="getValidationState(validationContext)"
                    type="text"
                    class="form-control"
                    v-model="newUOMForm.name"
                    placeholder="Enter Unit Name Name"
                  />
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </validation-provider>
              </b-col>
              <b-col sm="6" class="mb-3">
                <label class="form-label small fw-bold">Unit Symbol*</label>
                <validation-provider
                  name="product unit symbol"
                  rules="required"
                  v-slot="validationContext"
                >
                  <b-form-input
                    :state="getValidationState(validationContext)"
                    type="text"
                    class="form-control"
                    v-model="newUOMForm.unit"
                    placeholder="Enter Unit Symbol"
                  />
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </validation-provider>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12" class="mb-3">
                <label class="form-label small fw-bold"
                  >Unit of Measurement*</label
                >
                <validation-provider
                  name="product unit method"
                  rules="required"
                  v-slot="{ errors, ariaMsg }"
                >
                  <multiselect
                    v-model="newUOMForm.method"
                    :options="uomOptions"
                    track-by="value"
                    label="text"
                    name="brandCategory"
                    select-label="Click to select"
                    deselect-label="Click to remove"
                    placeholder="Select Unit Method"
                    :allow-empty="true"
                    :preselect-first="false"
                    :class="{
                      invalid: errors[0],
                    }"
                  ></multiselect>
                  <b-form-invalid-feedback v-bind="ariaMsg">
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </validation-provider>
              </b-col>
            </b-row>
            <b-row class="mb-3">
              <b-col>
                <b-btn class="w-100" type="submit" variant="primary">Create</b-btn>
              </b-col>
              <b-col>
                <b-button variant="light" class="w-100" @click="closeModal('bv-modal-uom')">Close</b-button>
              </b-col>
            </b-row>
          </b-form>
        </ValidationObserver>
        <div class="row" style="display:none;">
          <div class="col-sm-12">
            <!-- table responsive -->
            <div class="table-responsive">
              <div class="table align-middle table-nowrap">
                <b-table
                  :items="unitOfMeasurementList"
                  :fields="tblFields"
                  responsive="sm"
                >
                  <template #cell(name)="data">
                    <span>{{data.item.name}}</span>
                  </template>
                  <template #cell(unit)="data">
                    <span>{{data.item.unit}}</span>
                  </template>
                  <template #cell(method)="data">
                    <span>{{data.item.method}}</span>
                  </template>
                  <template #cell(action)="data">
                    <div class="d-flex">
                      <div class="btn-group me-2 mb-2 mb-sm-0">
                        <span class="text-primary c-pointer" @click="deleteUOM(data.item)">
                          remove
                        </span>
                      </div>
                    </div>
                  </template>
                </b-table>
              </div>
            </div>
            <div class="row g-0 text-center" v-if="unitOfMeasurementList.length == 0">
              <span>No data to display.</span>
            </div>
          </div><!--end of col-12-->
        </div><!--end of row-->
      </div>

    </b-modal>
  </div>
</template>

<script>
import {
  productListMethods,
  productListComputed,
  layoutMethods,
  erpUserRolesMethods
} from "@/state/helpers";
import Multiselect from "vue-multiselect";
import ImageUploader from "@/components/ImageUploader";
import Swal from "sweetalert2";
import _ from "lodash";
import { getModuleAccess } from '@/router/helper.js'

export default {
  components: {
    Multiselect,
    ImageUploader,
  },
  props: ["productId"],
  data() {
    return {
      folder: "product-images",
      uomOptions: [
        { text: "Piece", value: "Piece" },
        { text: "Length", value: "Length" },
        { text: "Scale", value: "Scale" },
      ],
      selectedUOM: null,
      currentTemplateItem: {},
      productTemplateItem: {
        productName: "",
        categoryIds: [],
        groupId: null,
        brandId: null,
        srp: "",
        cost: "",
        uom: {
          unit: "",
          name: "",
          method: "",
        },
        productCode: "",
      },
      productImage: {
        filename: null,
        type: null,
        base64: null,
      },
      formExitChecker: {
        productName: "",
        categoryIds: [],
        groupId: null,
        brandId: null,
        srp: "",
        cost: "",
        uom: {
          unit: "",
          name: "",
          method: "",
        },
        productCode: "",
      },
      redirectForm: true,
      newUOMForm:{
        unit:"",
        name:"",
        method:""
      },
      tblFields: [
        {
          key: 'name',
          sortable: false
        },
        {
          key: 'unit',
          sortable: false
        },
        {
          key: 'method',
          sortable: false
        },
        {
          key: 'action',
          sortable: false
        },
      ],
      productSuggestionModule: {
        access: {
          create: true,
          update: true
        }
      }
    };
  },
  computed: {
    ...productListComputed,
    mode: {
      get() {
        return this.productId ? "edit" : "add";
      },
    },
    productCategories: {
      get() {
        var selected = [];

        console.log(this.productTemplateItem.categoryIds);

        this.productCategoryOptions.forEach((pgo) => {
          console.log(pgo.value);
          if (this.productTemplateItem.categoryIds.includes(pgo.value)) {
            selected.push(pgo);
          }
        });
        return selected.length > 0 ? selected : null;
      },
      set(categories) {
        var selected = [];
        categories.forEach((c) => {
          selected.push(c.value);
        });
        this.productTemplateItem.categoryIds = selected;
      },
    },
    productBrand: {
      get() {
        var productBrand = null;
        this.productBrandOptions.forEach((b) => {
          if (b.value == this.productTemplateItem.brandId) {
            productBrand = b;
          }
        });
        return productBrand;
      },
      set(productBrand) {
        if (productBrand) {
          this.productTemplateItem.brandId = productBrand.value;
        } else {
          this.productTemplateItem.brandId = null;
        }
      },
    },
    productGroup: {
      get() {
        var productGroup = null;
        this.productGroupOptions.forEach((g) => {
          if (g.value == this.productTemplateItem.groupId) {
            productGroup = g;
          }
        });
        return productGroup;
      },
      set(productGroup) {
        if (productGroup) {
          this.productTemplateItem.groupId = productGroup.value;
        } else {
          this.productTemplateItem.groupId = null;
        }
      },
    },
    uomMethod: {
      get() {
        var uomMethod = null;
        this.uomOptions.forEach((u) => {
          if (u.value == this.productTemplateItem.uom.method) {
            uomMethod = u;
          }
        });
        return uomMethod;
      },
      set(uomMethod) {
        if (uomMethod) {
          this.productTemplateItem.uom.method = uomMethod.value;
        } else {
          this.productTemplateItem.uom.method = null;
        }
      },
    },
    productGroupOptions: {
      get() {
        return this.productGroups.map((group) => {
          return { text: group.groupName, value: group.groupId };
        });
      },
    },
    productCategoryOptions: {
      get() {
        return this.businessCategories.map((category) => {
          return { text: category.productName, value: category.productId };
        });
      },
    },
    productBrandOptions: {
      get() {
        return this.productBrands.map((brand) => {
          return { text: brand.productBrandName, value: brand.productId };
        });
      },
    },
  },
  methods: {
    ...layoutMethods,
    ...productListMethods,
    ...erpUserRolesMethods,
    goBack() {
      this.$router.go(-1);
    },
    saveProdTemplate() {
      var templateObj = { ...this.productTemplateItem };
      templateObj.productImageSrc = templateObj.productImageKey;
      delete templateObj.productImageKey;

      if (this.productImage.base64) {
        var productImage = { ...this.productImage };
        productImage.folder = this.folder;

        this.uploadLogo(productImage)
          .then((imageKey) => {
            templateObj = {
              ...templateObj,
              productImageSrc: imageKey,
            };
            this.update(templateObj);
          })
          .catch((err) => {
            Swal.fire("Upload Failed!", `${err}`, "error");
          });
      } else {
        this.update(templateObj);
      }
    },
    createProdTemplate() {
      var templateObj = {
        ...this.productTemplateItem,
        uom: JSON.stringify(this.productTemplateItem.uom),
      };
      delete templateObj.id;

      if (this.productImage.base64) {
        var productImage = { ...this.productImage };
        productImage.folder = this.folder;

        this.uploadLogo(productImage)
          .then((imageKey) => {
            templateObj = {
              ...templateObj,
              productImageSrc: imageKey,
            };

            this.create(templateObj);
          })
          .catch((err) => {
            Swal.fire("Upload Failed!", `${err}`, "error");
          });
      } else {
        this.create(templateObj);
      }
    },
    save() {
      if (this.productId) {
        this.saveProdTemplate();
      } else {
        this.createProdTemplate();
      }
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    create(templateObj) {
      if(Object.prototype.hasOwnProperty.call(templateObj, "uom")){
        templateObj.uom = JSON.stringify(this.selectedUOM);
      }
      this.createProductTemplate(templateObj)
        .then(() => {
          this.clearForm();
          this.clearLogo();
          Swal.fire({
            title: "Create Successful!",
            text: `${templateObj.productName} has been created.`,
            icon: "success",
            showCancelButton: true,
            cancelButtonText: "OK",
            confirmButtonColor: "#c4297c",
            cancelButtonColor: "#804997",
            confirmButtonText: "Back to Product Suggestion",
          }).then((result) => {
            if (result.value) {
              this.goToList();
            }
          });
        })
        .catch((err) => {
          // console.log("Product template form err:",err);
          Swal.fire(
            "Create Failed!",
            err.message ? err.message : `${templateObj.productName} was not created.`,
            "error"
          );
          this.clearLogo();
        });
    },
    update(templateObj) {
      var updatedItem = {
        ...templateObj,
        uom: JSON.stringify(this.selectedUOM)
      };

      var hasChanges = !_.isEqual(updatedItem, this.currentTemplateItem);
      if(!hasChanges){
        Swal.fire({
          title: `${templateObj.productName}`,
          text: "No changes made",
          icon: "info",
          showCancelButton: true,
          cancelButtonText: "OK",
          confirmButtonColor: "#c4297c",
          cancelButtonColor: "#804997",
          confirmButtonText: "Back to Product Suggestion",
        }).then((result) => {
          if (result.value) {
            this.goToList();
          }
        });
      } else {

        this.currentTemplateItem = _.cloneDeep(updatedItem);
        this.updateProductTemplate(updatedItem)
          .then(() => {
            this.redirectForm = false;
            Swal.fire({
              title: "Update Successful!",
              text: `${templateObj.productName} has been updated.`,
              icon: "success",
              showCancelButton: true,
              cancelButtonText: "OK",
              confirmButtonColor: "#c4297c",
              cancelButtonColor: "#804997",
              confirmButtonText: "Back to Product Suggestion",
            }).then((result) => {
              if (result.value) {
                this.goToList();
              }
            });
            this.clearLogo();
          })
          .catch((err) => {
            // console.log(err);
            Swal.fire(
              "Update Failed!",
              err.message? err.message : `${templateObj.productName} was not updated.`,
              "error"
            );
            this.clearLogo();
          });
      }
      
    },
    clearLogo() {
      this.productImage = {
        filename: null,
        type: null,
        base64: null,
      };
    },
    goToList(){
      this.redirectForm = false;
      this.$router.push({name:"Product Template"});
    },
    clearForm(){
      this.productTemplateItem = {
        productName: "",
        categoryIds: [],
        groupId: null,
        brandId: null,
        srp: "",
        cost: "",
        productImageSrc: null,
        uom: {
          unit: "",
          name: "",
          method: "",
        },
        productCode: "",
      },
      this.clearLogo();
      this.$refs.formReset.click();
    },
    leaveform(next){
      var temp ={
        productName: this.productTemplateItem.productName ,//"",
        categoryIds: this.productTemplateItem.categoryIds ,//[],
        groupId: this.productTemplateItem.groupId ,//null,
        brandId: this.productTemplateItem.brandId ,//null,
        srp: this.productTemplateItem.srp ,//"",
        cost: this.productTemplateItem.cost ,//"",
        uom: this.productTemplateItem.uom ,//,
        productCode: this.productTemplateItem.productCode ,//"",
      }
        if(JSON.stringify(temp) == JSON.stringify(this.formExitChecker)){
          next();
          return;
        }
        Swal.fire({
            title: 'Are you sure?',
            text: "you want to leave this page?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '##804997',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        }).then((result) => {
            if (result.isConfirmed) {
                next();
            }else{
                return;
            }
        })
    },
    getUOM(){
      this.getUnitOfMeasureList();
    },
    labelWithUnit({ name, unit }) {
      return `${name} (${unit})`;
    },
    openCreateNewUom(modal){
      this.$bvModal.show(modal);
    },
    closeModal(modal){
      this.$bvModal.hide(modal);
      this.newUOMForm = {unit:"",name:"",method:""}
    },
    newUOM(){
      // console.log(">> NEW UOM:",JSON.stringify(this.newUOMForm));
      var new_uom = {"unit": "", "name": "", "method": ""},
          self    = this;
      if(this.propExist(this.newUOMForm,'unit')){ new_uom.unit = this.newUOMForm.unit}
      if(this.propExist(this.newUOMForm,'name')){ new_uom.name = this.newUOMForm.name}
      if(this.propExist(this.newUOMForm,'method')){ 
        if(this.propExist(this.newUOMForm.method,'value')){ 
          new_uom.method = this.newUOMForm.method.value
        }
      }
      this.newUnitOfMeasure(new_uom)
        .then(() => {
          Swal.fire("Create Successful!", `${new_uom.name} has been created.`, "success");
          self.closeModal('bv-modal-uom');
          self.getUOM();
        })
        .catch(() => {
          Swal.fire("Create Failed!",`${new_uom.name} was not created.`, "error");
          self.closeModal('bv-modal-uom');
        });
    },
    propExist(obj, prop){
      return Object.prototype.hasOwnProperty.call(obj, prop);
    },
    deleteUOM(uom){
      // console.log(">> DELETE THIS:",uom);
      var self    = this;
        Swal.fire({
            title: "Are you sure?",
            text: `Do you really want to delete the ${uom.name} This process cannot be undone!`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#34c38f",
            cancelButtonColor: "#f46a6a",
            confirmButtonText: "Yes, delete it!",
        }).then((result) => {
          if(result.value) {
            this.delUnitOfMeasure(uom)
              .then(() => {
                self.getUOM();
              })
              .catch(() => {
              });
          }
        })
    },
    isNumber ($event) {
      //console.log($event.keyCode); //keyCodes value
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
          $event.preventDefault();
      }
    }
  },
  watch: {
    // 'productTemplateItem.srp': function (newVal){
    //       if(Object.prototype.hasOwnProperty.call(newVal, 'length'))
    //       {
    //         console.log(newVal);
    //         var temp = parseInt(newVal)
    //         var srp = isNaN(temp) || newVal.length == null ? 0 : parseInt(newVal.toString().replace(/[^\d]+/g,''));
    //         this.productTemplateItem.srp = srp;
    //       }
          
    //   },
    //   'productTemplateItem.cost': function (newVal){
    //       if(Object.prototype.hasOwnProperty.call(newVal, 'length'))
    //       {
    //         console.log(newVal);
    //         var temp = parseInt(newVal)
    //         var cost = isNaN(temp) || newVal.length == null ? 0 : parseInt(newVal.toString().replace(/[^\d]+/g,''));
    //         this.productTemplateItem.cost = cost;
    //       }
          
    //   },
  },
  async mounted() {
    console.log('productId: ', this.productId)
    // Dropdown values
    this.listProductBrands({ rows: 99999 });
    this.listProductGroups({ rows: 99999 });
    this.listBusinessCategories({ rows: 99999 });

    // Product list
    var text = this.mode == 'add' ? 'Add' : 'Edit'
    this.changeTitle({ title: `${text} Product Suggestion` });
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: 'Peddlr', to: { name: 'Home'}},
        { text: 'Product Template' },
        { text: 'Product Suggestion', to: { name: 'Product Template'} },
        { text:  `${text} Product Suggestion`, to: { name: 'Product Template Form'} }
      ]
    });

    this.getUOM();
    if (this.productId) {
      var self = this;
      this.getProductTemplate(this.productId).then((item) => {
        if (!item.uom) {
          item.uom = {
            unit: "",
            name: "",
            method: "",
          };
        }
        self.selectedUOM = item.uom;
        console.log(item);

        item.categoryIds = item.categories.map((category) =>
          parseInt(category.categoryId)
        );
        item.id = item.productId;

        delete item.productId;
        delete item.categories;
        delete item.brandName;
        delete item.groupName;

        this.productTemplateItem = item;
        this.formExitChecker = {
        productName: item.productName ,//"",
        categoryIds: item.categoryIds ,//[],
        groupId: item.groupId ,//null,
        brandId: item.brandId ,//null,
        srp: item.srp ,//"",
        cost: item.cost ,//"",
        uom: item.uom ,//,
        productCode: item.productCode ,//"",
      };
        
        
        this.currentTemplateItem = _.cloneDeep(item);
        this.currentTemplateItem.productImageSrc = item.productImageKey;
        this.currentTemplateItem.uom = JSON.stringify(this.currentTemplateItem.uom);
        delete this.currentTemplateItem.productImageKey;
      });
    }

    // get the module access for checking if user has create, read, update, and/or delete access
    await getModuleAccess('Utilities', 'Product Template', 'Product Suggestion')
        .then((access) => this.productSuggestionModule.access = access);
    
  },
  beforeRouteLeave(to, from, next) {
      console.log("><><><><> HEY",this.redirectForm,JSON.stringify(this.productTemplateItem),JSON.stringify(this.formExitChecker));
      if(this.redirectForm){
        this.leaveform(next);
      }else{
        next();
      }
  }
};
</script>

<style>
.multiselect.invalid .multiselect__tags {
  border-color: #f34e4e;
  padding-right: calc(1.5em + 0.94rem);
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23f34e4e'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23f34e4e' stroke='none'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.235rem) center;
  background-size: calc(0.75em + 0.47rem) calc(0.75em + 0.47rem);
}

.invalid ~ .invalid-feedback {
  display: block;
}

.multiselect__option--highlight,
.multiselect__option--highlight::after {
  background: #f8f9fa;
  color: #495057;
}

.multiselect__tag {
  background-color: #e73092 !important;
  border-color: #e73092 !important;
  margin-bottom: 0 !important;
  font-weight: 400 !important;
}

.multiselect__tag-icon:after {
  color: #fff !important;
}

.multiselect__tag-icon:focus,
.multiselect__tag-icon:hover {
  background-color: #e73092 !important;
}

.w-90 {
  width: 90%;
}
</style>